export const getChildFullName = (child) =>
  [child?.firstName, child?.lastName].filter(Boolean).join(" ").trim();

export const getChildInitials = (child) =>
  [child?.firstName, child?.lastName]
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase())
    .join("");
